export default class JobStatus {
  public static readonly Scheduled: string = "Scheduled";
  public static readonly InProgress: string = "InProgress";
  public static readonly Completed: string = "Completed";
  public static readonly CompletedWithWarnings: string =
    "CompletedWithWarnings";
  public static readonly Error: string = "Error";
  public static readonly Cancelled: string = "Cancelled";
}
